import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import IssueDetailLayout from "../components/IssueDetailLayout";
import { fetchIssueByKey } from "../../../../core/data/redux/projects/thunks";
import {
  selectActiveIssue,
  selectActiveIssueLoading,
  selectCurrentProject,
} from "../../../../core/data/redux/projects/selectors";
import { all_routes } from "../../../router/all_routes";

import type { AppDispatch, RootState } from "../../../../core/data/redux/store";

const IssueDetails: React.FC = () => {
  const { projectKey, issueKey } = useParams<{
    projectKey: string;
    issueKey: string;
  }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const project = useSelector(selectCurrentProject);
  const issue = useSelector(selectActiveIssue);
  const loading = useSelector(selectActiveIssueLoading);
  const currentUserId = useSelector(
    (state: RootState) => (state as any).user?.id ?? null
  );

  useEffect(() => {
    if (issueKey) dispatch(fetchIssueByKey(issueKey));
  }, [dispatch, issueKey]);

  const handleBack = () => {
    if (project) {
      navigate(
        all_routes.projectBoard.replace(":projectKey", project.key)
      );
    } else if (projectKey) {
      navigate(all_routes.projectBoard.replace(":projectKey", projectKey));
    }
  };

  return (
    <div>
      <div className="mb-3 d-flex align-items-center gap-2">
        <button
          type="button"
          className="btn btn-info btn-sm"
          onClick={handleBack}
        >
          <i className="ti ti-arrow-left me-1" />
          Back to board
        </button>
      </div>
      <IssueDetailLayout
        issue={issue}
        loading={loading}
        currentUserId={currentUserId}
      />
    </div>
  );
};

export default IssueDetails;
